import { LIVE_CASINO_CATEGORY } from 'utils/constants/casino/casino_categories';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import {
  ENewCasinoGamesFetchingParamsKey,
  NewCasinoGamesFetchingParams
} from 'interfaces/new-casino';
import type { CasinoGamesConfigs } from '../providers/CasinoGamesConfigsContext';

export const INITIAL_FETCH_PARAMS_STATE: Partial<NewCasinoGamesFetchingParams> =
  {
    by_key: ENewCasinoGamesFetchingParamsKey.Category,
    external_id: undefined,
    provider: undefined
  };

export const INITIAL_FETCH_PARAMS_STATE_FOR_SKIP_QUERY_KEYS_CHECK_ALL_CATEGORY: Partial<NewCasinoGamesFetchingParams> =
  {
    by_key: ENewCasinoGamesFetchingParamsKey.Id,
    external_id: undefined,
    provider: undefined,
    _fake_category: CUSTOM_CATEGORIES.all.id
  };

export const INITIAL_FETCH_PARAMS_STATE_FOR_SKIP_QUERY_KEYS_CHECK_LIVE_CASINO_CATEGORY: Partial<NewCasinoGamesFetchingParams> =
  {
    by_key: ENewCasinoGamesFetchingParamsKey.Id,
    external_id: undefined,
    provider: undefined,
    category: `${LIVE_CASINO_CATEGORY}`
  };

const INITIAL_FETCH_PARAMS_BY_SKIP_CATEGORY: Record<
  string,
  Partial<NewCasinoGamesFetchingParams>
> = {
  [CUSTOM_CATEGORIES.all.id]:
    INITIAL_FETCH_PARAMS_STATE_FOR_SKIP_QUERY_KEYS_CHECK_ALL_CATEGORY,
  [`${LIVE_CASINO_CATEGORY}`]:
    INITIAL_FETCH_PARAMS_STATE_FOR_SKIP_QUERY_KEYS_CHECK_LIVE_CASINO_CATEGORY
};

export const getInitialFetchParams = (configs: Partial<CasinoGamesConfigs>) => {
  return configs.skipQueryKeysCheck
    ? INITIAL_FETCH_PARAMS_BY_SKIP_CATEGORY[
        configs.categoryIds || CUSTOM_CATEGORIES.all.id
      ] || INITIAL_FETCH_PARAMS_STATE
    : INITIAL_FETCH_PARAMS_STATE;
};
